// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__FedraSerifDisplayBold_bd4051', '__FedraSerifDisplayBold_Fallback_bd4051'"},"className":"__className_bd4051","variable":"__variable_bd4051"};